module.exports = __webpack_public_path__ + "img/marion.47c0b1d2.jpg";